module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am5_m.41807d4a6236b02a98270e9b983d4572.png";